<script lang="ts">
	import ProductFiltrationLabel from "./Product/ProductFiltrationLabel.svelte";

	export let filters: string[];
	export let selectedFilters: string[];

	function clearFilters(): void {
		selectedFilters = [];
	}

	function toggleFilter(filter: string): void {
		if (selectedFilters.includes(filter)) {
			selectedFilters = selectedFilters.filter((selectedFilter) => selectedFilter !== filter);
		} else {
			selectedFilters = [...selectedFilters, filter];
		}
	}

	// eslint-disable-next-line no-warning-comments
	// FIXME remove this after upgrade to Svelte 5.
	/* eslint-disable @typescript-eslint/explicit-function-return-type */
</script>

<div class="mx-auto my-4 flex w-fit flex-col items-center gap-1 md:flex-row md:gap-4">
	<p class="text-base font-semibold leading-6">Filtr</p>
	<div class="flex flex-wrap items-center justify-center gap-1.5">
		<button
			on:click={clearFilters}
			class="text-2xs text-secondaryBlack rounded-full border bg-white px-3 font-normal leading-5"
			class:border-primaryRed={selectedFilters.length === 0}
			class:!text-primaryRed={selectedFilters.length === 0}
		>
			Vše
		</button>
		{#each filters as filter}
			{@const selected = selectedFilters.includes(filter)}
			<ProductFiltrationLabel
				label={filter}
				{selected}
				clickable
				on:click={() => {
					toggleFilter(filter);
				}}
			/>
		{/each}
	</div>
</div>
